module.exports = "<svg fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n  <path d=\"M20,14H4V10H20\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/minimize.svg
// module id = 809
// module chunks = 1